import { ErrorInfo, ErrorCode } from "@/network/http";
import { requestData } from "./base";
import { PageReq, BaseReq, BaseRsp, GetInfoByIdReq } from "@/data/remote/base";
import { nullPageInfo } from "@/data/local/base";
import { 
    GetTopicListReq, 
    GetTopicListRsp,
    GetTopicDetailRsp,
    GetSelfTopicListReq,
    CreateTopicReq,
    GetAnswerListReq,
    GetAnswerListRsp,
    ReplyTopicReq
} from '@/data/remote/discuss'
import { DiscussTopicList, DiscussAnswerList, DiscussTopicInfo } from '@/data/local/discuss'

const URL_GET_DISCUSS_TOPIC_LIST = "/wxyj/discuss/topic/getTopicList";// 讨论主题列表
const URL_GET_DISCUSS_TOPIC_DETAIL = "/wxyj/discuss/topic/getTopicDetail";// 讨论主题详情
const URL_GET_SELF_DISCUSS_TOPIC_LIST = "/wxyj/discuss/topic/getSelfTopicList";//我的主题列表
const URL_CREATE_TOPIC_DISCUSS = "/wxyj/discuss/topic/createTopic";//创建主题
const URL_GET_DISCUSS_ANSWER_LIST = "/wxyj/discuss/answer/getAnswerList"; //答案列表
const URL_REPLY_TOPIC = "/wxyj/discuss/answer/replyTopic"; //回复主题

export const getDiscussTopicList = (keyword: string, areaId: number, type: number, cat: number | null, pageNo: number, pageSize: number, callback?: (errorInfo: ErrorInfo, data: DiscussTopicList) => void) => {
    const payload: GetTopicListReq = {
        keyword,
        areaId,
        type,
        cat,
        pageNo,
        pageSize
    };

    requestData(URL_GET_DISCUSS_TOPIC_LIST, payload, (errorInfo: ErrorInfo, data: GetTopicListRsp) => {
        let rspData: DiscussTopicList = (errorInfo.errorCode === ErrorCode.SUCCESS) ? {
            list: [...data.list],
            pagination: {
                pageNo: data.pageNo,
                pageSize: data.pageSize,
                totalCount: data.totalCount,
                totalPage: data.totalPage
            }
        } : nullPageInfo;
        callback && callback(errorInfo, rspData);
    });
}

export const getDiscussDetail = (id: number, callback?: (errorInfo: ErrorInfo, data: DiscussTopicInfo | null) => void) => {
    const payload: GetInfoByIdReq = {
        id
    };

    requestData(URL_GET_DISCUSS_TOPIC_DETAIL, payload, (errorInfo: ErrorInfo, data: GetTopicDetailRsp) => {
        let rspData: DiscussTopicInfo | null = (errorInfo.errorCode === ErrorCode.SUCCESS) ? {...data} : null;
        callback && callback(errorInfo, rspData);
    });
}

export const getSelfTopicList = (type: number, cat: number | null, pageNo: number, pageSize: number, callback?: (errorInfo: ErrorInfo, data: DiscussTopicList) => void) => {
    const payload: GetSelfTopicListReq = {
        type,
        cat,
        pageNo,
        pageSize
    };

    requestData(URL_GET_SELF_DISCUSS_TOPIC_LIST, payload, (errorInfo: ErrorInfo, data: GetTopicListRsp) => {
        let rspData: DiscussTopicList = (errorInfo.errorCode === ErrorCode.SUCCESS) ? {
            list: [...data.list],
            pagination: {
                pageNo: data.pageNo,
                pageSize: data.pageSize,
                totalCount: data.totalCount,
                totalPage: data.totalPage
            }
        } : nullPageInfo;
        callback && callback(errorInfo, rspData);
    });
}


export const createTopic = (areaId: number, type: number, cat: number, email: string | null, content: string, callback?: (errorInfo: ErrorInfo) => void) => {
    const payload: CreateTopicReq = {
        areaId,
        type,
        cat,
        email,
        content
    };

    requestData(URL_CREATE_TOPIC_DISCUSS, payload, (errorInfo: ErrorInfo, data: BaseRsp) => {
        callback && callback(errorInfo);
    });
}

export const getDiscussAnswerList = (topicId: number, pageNo: number, pageSize: number, callback?: (errorInfo: ErrorInfo, data: DiscussAnswerList) => void) => {
    const payload: GetAnswerListReq = {
        topicId,
        pageNo,
        pageSize
    };

    requestData(URL_GET_DISCUSS_ANSWER_LIST, payload, (errorInfo: ErrorInfo, data: GetAnswerListRsp) => {
        let rspData: DiscussAnswerList = (errorInfo.errorCode === ErrorCode.SUCCESS) ? {
            list: [...data.list],
            pagination: {
                pageNo: data.pageNo,
                pageSize: data.pageSize,
                totalCount: data.totalCount,
                totalPage: data.totalPage
            }
        } : nullPageInfo;
        callback && callback(errorInfo, rspData);
    });
}

export const replyTopic = (topicId: number, content: string, callback?: (errorInfo: ErrorInfo) => void) => {
    const payload: ReplyTopicReq = {
        topicId,
        content
    };

    requestData(URL_REPLY_TOPIC, payload, (errorInfo: ErrorInfo, data: BaseRsp) => {
        callback && callback(errorInfo);
    });
}